import { nullSafeString } from "../stringUtils";

export function getSenderProjectDetails(record: any): string {
  return `Project: ${nullSafeString(record.docProjectName)} (${nullSafeString(record.docProjectCode)}) \t\tVirtual Locator: ${
    record.docVirtualLocator
  }`;
}

export function getReceiverProjectDetails(record: any): string {
  return `Project: ${nullSafeString(record.receiverProjectName)} (${nullSafeString(
    record.receiverProjectCode
  )}) \t\tVirtual Locator: ${nullSafeString(record.receiverVirtualLocator)}`;
}
